import axios from 'axios';

const API_BASE_URL = 'https://ptsspl.in/public/api';

export interface ErrorEntry {
  id: number;
  user_id: number;
  department: string;
  error_type: string;
  notes: string | null;
  created_at: string;
  updated_at: string;
}

class ErrorEntryService {
  async getAll(): Promise<ErrorEntry[]> {
    try {
      const response = await axios.get(`${API_BASE_URL}/error-entries`);
      return response.data;
    } catch (error) {
      throw new Error('Failed to fetch error entries');
    }
  }

  async getById(id: number): Promise<ErrorEntry> {
    try {
      const response = await axios.get(`${API_BASE_URL}/error-entries/${id}`);
      return response.data;
    } catch (error) {
      throw new Error('Failed to fetch error entry');
    }
  }

  async create(entryData: Omit<ErrorEntry, 'id' | 'created_at' | 'updated_at'>): Promise<ErrorEntry> {
    try {
      const response = await axios.post(`${API_BASE_URL}/error-entries`, entryData);
      return response.data;
    } catch (error) {
      throw new Error('Failed to create error entry');
    }
  }

  async update(id: number, entryData: Partial<Omit<ErrorEntry, 'id' | 'created_at' | 'updated_at'>>): Promise<ErrorEntry> {
    try {
      const response = await axios.put(`${API_BASE_URL}/error-entries/${id}`, entryData);
      return response.data;
    } catch (error) {
      throw new Error('Failed to update error entry');
    }
  }

  async delete(id: number): Promise<void> {
    try {
      await axios.delete(`${API_BASE_URL}/error-entries/${id}`);
    } catch (error) {
      throw new Error('Failed to delete error entry');
    }
  }
}

const errorEntryService = new ErrorEntryService();
export default errorEntryService;